import * as React from 'react'
import { TaskSummarySpanConnected } from './TaskSummarySpanConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const TaskSummarySpanExamples = () => {
  return (
    <div className="TaskSummarySpanExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskSummarySpanConnected taskId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
